
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, deleteData } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const VehicleType = ({ menuText }) => {
    //--Inital State--//
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
  
    const [formData, setFormData] = useState({
        vehicleTypeID: "",
        container: '',
        active: true,
    })

    //--Handle Clear Function--//
    const handleClear = () => {
        setFormData({
            vehicleTypeID: "",
            container:'',
            active: true,
        });
        filterData.SearchText = ''
        getVehicleTypeData()
        inputrefs.current['txtContainer'].focus();
    };

    //--handle Submit Function--//
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/master/InsertUpdateVehicleTypeMaster', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }

    //--handle Delete Function--//
    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteVehicleTypeMaster', { vehicleTypeID: ID }, getVehicleTypeData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    //--handle Sorting Function--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    //--handle Edit Function--//
    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditVehicleTypeMaster', { vehicleTypeID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }

    }

    //--Grid Data Fetch Function--//
    const getVehicleTypeData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowVehicleTypeMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getVehicleTypeData(value);
    };

   
    useEffect(() => {
        getVehicleTypeData();
    }, [sortConfig])

    useEffect(() => {
        inputrefs.current['txtContainer'].focus();
        document.title = 'Vehicle Type'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('Vehicle Type')}</h6>
                </div>
                <div className='card-body row'>

                    <div className='row'>
                       
                        <InputBox
                            label='Container'
                            inputrefs={inputrefs}
                            id='txtContainer'
                            PlaceHolderText='Container'
                            value={formData.container}
                            onChange={(e) => setFormData({ ...formData, container: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtActive'].focus()
                                }
                            }}
                            required={true}
                            maxLength='300'
                        />
                   
                       
                        <Switch
                            inputrefs={inputrefs}
                            label='Active'
                            checked={formData.active}
                            extraclassname='form-check form-switch mt-3'
                            divclassname='col-md-1 mb-1 '
                            id='txtActive'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['btnSave'].focus()
                                };
                            }}
                            onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                            autoComplete="off"
                        />
                       

                      
                    </div>

                    <div className='row pb-1 mt-2'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                await handleDownloadExcel('/api/Master/ShowVehicleTypeMaster', filterData, 'Vehicle Type')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear} />
                    </div>

                </div>

            </div>
            <Table handleEdit={handleEdit}
                handleDelete={handleDelete}
                PageName={'VehicleType'}
                loading={loading}
                handleFilter={() => {
                    getVehicleTypeData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={result}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />

        </>
    )
}

export default VehicleType;